import { useAuthenticator } from '@aws-amplify/ui-react'
import { AuthUser, fetchAuthSession } from 'aws-amplify/auth'
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

export interface UserContextType {
  user: AuthUser | null
  token: string
  signOut: (data?: any) => void
}

export const UserContext = createContext<UserContextType>({
  user: null,
  token: '',
  signOut: () => {},
})

interface UserProviderProps {
  children?: ReactNode
}

export const UserProvider = ({ children }: UserProviderProps) => {
  const { user, signOut } = useAuthenticator((context) => [
    context.user,
    context.signOut,
  ])

  const [token, setToken] = useState('')

  const getToken = async () => {
    if (user) {
      try {
        const session = await fetchAuthSession()
        const idToken = session.tokens?.idToken?.toString() ?? ''
        if (idToken !== '') {
          setToken(idToken)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  useEffect(() => {
    getToken()
  }, [user])

  return (
    <UserContext.Provider
      value={{
        user,
        token,
        signOut,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => useContext(UserContext)
